// ==============================|| SCROLL ITEMS ||============================== //

const scrollItems = {
  general: [],
}

export default scrollItems
